{
	"empty": "Sem dados para serem exibidos",
	"table": "Tabela"
}
